import i18next from 'i18next'
import {initReactI18next} from 'react-i18next'
import resources from './resources'
import LanguageDetector from 'i18next-browser-languagedetector'

async function initialise() {
  i18next.use(initReactI18next).use(LanguageDetector).init({
    compatibilityJSON: 'v3',
    lng:'mne',
    resources: resources,
    fallbackLng: 'mne',
    interpolation: {
        escapeValue: false,
    },
    postProcess: ['newline'],
  });
}

export default initialise;
